// src/elementos/gruposEstilos.js
// Estilos compartidos de gestión de grupos (prefijo gg-).
// Misma paleta que la vista de seguimiento del profesor.

export const estilosGrupos = `
.gg {
  --gg-tinta: #1d2a3a;
  --gg-sutil: #5f6b7a;
  --gg-linea: #dfe4ea;
  --gg-fondo: #f6f8fa;
  --gg-superficie: #ffffff;
  --gg-acento: #23577a;
  --gg-acento-suave: #e8f0f6;
  --gg-exito: #2f7d4f;
  --gg-aviso: #b7791f;
  --gg-peligro: #b42318;
  color: var(--gg-tinta);
  font-family: inherit;
  line-height: 1.45;
}
.gg h1, .gg h2, .gg h3, .gg h4 { margin: 0; }
.gg-pagina { max-width: 1100px; margin: 32px auto; padding: 0 20px; }
.gg-sutil { color: var(--gg-sutil); font-size: 0.9rem; margin: 0; }
.gg-encabezado { display: flex; justify-content: space-between; align-items: center; gap: 16px; flex-wrap: wrap; margin-bottom: 24px; }
.gg-encabezado h1 { font-size: 1.6rem; }

/* Botones */
.gg-btn {
  display: inline-flex; align-items: center; justify-content: center; gap: 6px;
  border: 1px solid var(--gg-linea); background: var(--gg-superficie); color: var(--gg-tinta);
  padding: 8px 14px; border-radius: 8px; font: inherit; font-size: 0.92rem; cursor: pointer;
  text-decoration: none; white-space: nowrap;
}
.gg-btn:hover { border-color: var(--gg-acento); }
.gg-btn:disabled { opacity: 0.55; cursor: not-allowed; }
.gg-btn--primario { background: var(--gg-acento); border-color: var(--gg-acento); color: #fff; }
.gg-btn--primario:hover { background: #1b4562; }
.gg-btn--peligro { color: var(--gg-peligro); border-color: #f2c6c2; }
.gg-btn--peligro:hover { background: #fdecea; border-color: var(--gg-peligro); }
.gg-btn--exito { color: var(--gg-exito); border-color: #bfdcc9; }
.gg-btn--exito:hover { background: #e9f5ee; border-color: var(--gg-exito); }
.gg-btn--chico { padding: 5px 10px; font-size: 0.85rem; }
.gg-btn--ancho { width: 100%; padding: 12px 14px; font-size: 1rem; }

/* Tarjetas de grupo */
.gg-grid { display: grid; grid-template-columns: repeat(auto-fill, minmax(300px, 1fr)); gap: 16px; }
.gg-tarjeta {
  background: var(--gg-superficie); border: 1px solid var(--gg-linea); border-radius: 12px;
  padding: 18px; display: flex; flex-direction: column; gap: 12px;
}
.gg-tarjeta__cabecera { display: flex; justify-content: space-between; align-items: flex-start; gap: 10px; }
.gg-tarjeta__nombre { font-size: 1.05rem; overflow-wrap: anywhere; }
.gg-tarjeta__acciones { display: flex; flex-wrap: wrap; gap: 8px; margin-top: auto; padding-top: 12px; border-top: 1px solid var(--gg-linea); }
.gg-cifras { display: flex; gap: 18px; flex-wrap: wrap; font-size: 0.9rem; }
.gg-cifras strong { font-size: 1.1rem; }

.gg-insignia {
  display: inline-block; padding: 2px 10px; border-radius: 999px; font-size: 0.78rem; font-weight: 600;
  background: var(--gg-fondo); color: var(--gg-sutil); white-space: nowrap;
}
.gg-insignia--admin { background: var(--gg-acento-suave); color: var(--gg-acento); }
.gg-insignia--aviso { background: #fbf1df; color: #8a5a12; }
.gg-insignia--exito { background: #e5f3ea; color: var(--gg-exito); }
.gg-etiquetas { display: flex; flex-wrap: wrap; gap: 6px; }

/* Modal */
.gg-fondo {
  position: fixed; inset: 0; background: rgba(17, 24, 39, 0.45); z-index: 1000;
  display: flex; align-items: flex-start; justify-content: center; padding: 40px 16px; overflow-y: auto;
}
.gg-modal {
  background: var(--gg-superficie); border-radius: 14px; width: 100%; max-width: 560px;
  padding: 22px 24px 24px; box-shadow: 0 20px 50px rgba(0,0,0,0.18);
}
.gg-modal--ancho { max-width: 680px; }
.gg-modal__cabecera { display: flex; justify-content: space-between; align-items: flex-start; gap: 12px; margin-bottom: 16px; }
.gg-modal__cabecera h2 { font-size: 1.2rem; }
.gg-cerrar { background: none; border: 0; font-size: 1.4rem; line-height: 1; cursor: pointer; color: var(--gg-sutil); padding: 2px 6px; }

/* Formularios */
.gg-campo { display: flex; flex-direction: column; gap: 6px; margin-bottom: 14px; }
.gg-campo label, .gg-campo legend { font-weight: 600; font-size: 0.92rem; }
.gg-input, .gg-textarea {
  width: 100%; box-sizing: border-box; padding: 10px 12px; border: 1px solid var(--gg-linea);
  border-radius: 8px; font: inherit; background: var(--gg-superficie); color: var(--gg-tinta);
}
.gg-textarea { min-height: 80px; resize: vertical; }
.gg-checks { display: flex; flex-wrap: wrap; gap: 8px 18px; border: 0; padding: 0; margin: 0; }
.gg-checks label { font-weight: 400; display: inline-flex; gap: 6px; align-items: center; }
.gg-botonera { display: flex; justify-content: flex-end; gap: 10px; margin-top: 8px; }

/* Pestañas */
.gg-pestanas { display: flex; gap: 4px; border-bottom: 1px solid var(--gg-linea); margin-bottom: 16px; }
.gg-pestana {
  background: none; border: 0; border-bottom: 2px solid transparent; padding: 9px 14px;
  font: inherit; color: var(--gg-sutil); cursor: pointer; margin-bottom: -1px;
}
.gg-pestana.is-activo { color: var(--gg-tinta); border-bottom-color: var(--gg-acento); font-weight: 600; }

/* Invitación */
.gg-codigo {
  font-family: ui-monospace, SFMono-Regular, Menlo, monospace; font-size: 1.9rem; font-weight: 700;
  letter-spacing: 0.18em; color: var(--gg-acento);
}
.gg-enlace-caja {
  display: flex; gap: 8px; align-items: center; background: var(--gg-fondo);
  border: 1px solid var(--gg-linea); border-radius: 8px; padding: 6px 6px 6px 12px;
}
.gg-enlace-caja span { flex: 1; font-size: 0.88rem; overflow-wrap: anywhere; }
.gg-invitacion { display: grid; grid-template-columns: auto 1fr; gap: 20px; align-items: start; }
.gg-qr { background: #fff; border: 1px solid var(--gg-linea); border-radius: 10px; padding: 8px; display: flex; flex-direction: column; align-items: center; gap: 8px; }
.gg-compartir { display: flex; flex-wrap: wrap; gap: 8px; }
.gg-bloque { display: flex; flex-direction: column; gap: 12px; }

/* Listas de miembros */
.gg-seccion { margin-top: 20px; }
.gg-seccion__titulo { display: flex; align-items: center; gap: 8px; font-size: 1rem; margin-bottom: 8px; }
.gg-filas { list-style: none; margin: 0; padding: 0; border: 1px solid var(--gg-linea); border-radius: 10px; }
.gg-fila { display: flex; align-items: center; justify-content: space-between; gap: 10px; padding: 10px 12px; flex-wrap: wrap; }
.gg-fila + .gg-fila { border-top: 1px solid var(--gg-linea); }
.gg-fila__nombre { font-weight: 600; overflow-wrap: anywhere; }
.gg-fila__acciones { display: flex; gap: 6px; flex-wrap: wrap; }
.gg-zona-cuidado { margin-top: 24px; padding: 14px; border: 1px solid #f2c6c2; border-radius: 10px; background: #fffafa; }

/* Mensajes */
.gg-alerta { background: #fdecea; color: var(--gg-peligro); padding: 10px 14px; border-radius: 8px; margin: 0 0 14px; }
.gg-exito { background: #e9f5ee; color: var(--gg-exito); padding: 10px 14px; border-radius: 8px; margin: 0 0 14px; }
.gg-aviso-flotante {
  position: fixed; left: 50%; bottom: 24px; transform: translateX(-50%); z-index: 1100;
  background: var(--gg-tinta); color: #fff; padding: 8px 16px; border-radius: 999px; font-size: 0.9rem;
}
.gg-vacio { border: 1px dashed var(--gg-linea); border-radius: 12px; padding: 32px 20px; text-align: center; color: var(--gg-sutil); }

/* Página de invitación */
.gg-portada { min-height: 100vh; display: flex; align-items: center; justify-content: center; padding: 24px 16px; background: var(--gg-fondo); box-sizing: border-box; }
.gg-portada__tarjeta { width: 100%; max-width: 460px; background: var(--gg-superficie); border: 1px solid var(--gg-linea); border-radius: 16px; padding: 28px 26px; display: flex; flex-direction: column; gap: 14px; }
.gg-portada__grupo { font-size: 1.5rem; overflow-wrap: anywhere; }

.gg button:focus-visible, .gg a:focus-visible, .gg input:focus-visible, .gg textarea:focus-visible {
  outline: 2px solid var(--gg-acento); outline-offset: 2px;
}

@media (max-width: 560px) {
  .gg-invitacion { grid-template-columns: 1fr; }
  .gg-qr { justify-self: center; }
  .gg-modal { padding: 18px 16px 20px; }
}
`;